export const FirebaseConfig = {
	"projectId": "point-driver-app",
	"appId": "1:1071510583729:web:01dab3e79e56055e572590",
	"databaseURL": "https://point-driver-app-default-rtdb.firebaseio.com",
	"storageBucket": "point-driver-app.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyDNOOb6VZLGS_gG_h9LidbfNnoSi-JELac",
	"authDomain": "point-driver-app.firebaseapp.com",
	"messagingSenderId": "1071510583729"
};